let translate;

export const setTranslation = (fn) => {
  translate = fn;
};

export const $t = (key, options) => {
  return translate(key, options);
};